import { useTheme } from '@mui/material';
import {
  AIIcon,
  SaveCostsIcon,
  RobotIcon,
  BrainIcon,
  AIWithWebIcon,
} from '@rumblefish/ui/Rumblefish23Theme';
import type { IAccordionData } from '@rumblefish/ui/src/components/Rumblefish23Theme/Accordion/CustomizedAccordion.types';

export const benefitsData = {
  mainText: `The benefits of implementing an <br/> AI-powered chatbot assistant`,
  description: `Discover the transformative benefits of implementing an AI chatbot in your operations.`,
};

export const AccordionData = (): IAccordionData[] => {
  const theme = useTheme();
  return [
    {
      title: 'AI Chatbot is smarter than your usual bot',
      description:
        'LLM- or RAG-driven chatbots not only understand user queries but also retrieve contextually relevant information, making interactions more personalized and intelligent. The AI Chatbot goes beyond scripted responses, utilizing sophisticated language models like GPT-4, allowing it to generate human-like text and adapt to a diverse range of user inputs. Through continuous learning and adaptation, custom AI Chatbots evolve over time, becoming increasingly adept at understanding the nuances of user intent and providing more accurate and context-aware responses.',
      icon: BrainIcon,
      gradientOnFocus: theme.mixins.cyanGradient?.background as string,
    },

    {
      title: 'AI Chatbot will save you time & lower your costs',
      description:
        'The implementation of AI chatbots translates directly to cost savings by reducing the need for human intervention in repetitive tasks. With the ability to handle a high volume of inquiries simultaneously, it minimizes the workload on your staff, leading to more efficient operations and decreased labor costs.',
      icon: SaveCostsIcon,
      gradientOnFocus: theme.mixins.blueGradient?.background as string,
    },
    {
      title: 'AI Chatbot will enhance customer satisfaction',
      description:
        'Time is money, and AI Chatbots not only accelerate response times but also operate 24/7, ensuring that your customers or clients receive instant assistance regardless of the hour. This round-the-clock availability translates into significant time savings for both your team and your end-users. Personalized interactions and proactive assistance are at the core of AI assistant’s capabilities, fostering a sense of connection and responsiveness that contributes to heightened customer satisfaction levels.',
      icon: RobotIcon,
      gradientOnFocus: theme.mixins.violetGradient?.background as string,
    },
    {
      title: 'AI Chatbots boost lead generation',
      description:
        'Turbocharge your lead generation efforts with a custom AI Chatbot developed by Rumble Fish. AI assistants are built to engage potential customers instantly and capture valuable information. By providing proactive and responsive interaction, our chatbots transform casual website visitors into qualified leads. AI Chatbots can be also used beyond lead generation, to analyze user data and behavior to provide valuable insights into your target audience. These insights empower your marketing and sales teams with the information needed to refine strategies and enhance lead generation campaigns.',

      icon: AIWithWebIcon,
      gradientOnFocus: theme.mixins.grapeGradient?.background as string,
    },
    {
      title: 'AI Chatbots deliver multilingual support',
      description: `The AI Chatbots' language versatility extends beyond translation, understanding the nuances of different languages to provide accurate and contextually relevant responses. This ensures that users feel understood and receive information in a way that resonates with their cultural context.`,
      icon: AIIcon,
      gradientOnFocus: theme.mixins.purpleGradient?.background as string,
    },
  ];
};
